<svelte:head>

    <link rel='stylesheet' href='/global.css' />
    <link rel="stylesheet" type="text/css" href="css/charts.css" />

</svelte:head>

<script>

    import {
        errorReasons,
        listProperties,
        getDashboardData
    } from './api.svelte'

    import {
        getLocalPropertyId,
        checkUnauthorized
    } from "../utils/session";

    import {
        periodIdentifiers,
        getChangeClass,
        getChangePercent,
        charts,
        setupChartPeriodic,
        setupChartCumulative,
        setupChartsAudience,
        setupChartOrigins,
        handleKeyword
    } from "./utils/dashboard"

    import highcharts from "../utils/highcharts";
    import highchartsmap from "../utils/highchartsmap";

    import { onMount } from "svelte";
    import { getContext } from "svelte";
    import PropertySelection from "./propertyselection.svelte";


    const router = getContext('router');


    let dashboardData;

    let hasAudienceData;

    let chartPeriodicConfig;
    let chartCumulativeConfig;
    let chartGenderConfig;
    let chartAgesConfig;
    let chartOriginConfig;

    let keywordInfo;


    onMount(() => {

        loadDashboardData();

    });

    let loadDashboardData = () => {

        let propertyId = getLocalPropertyId();

        getDashboardData(propertyId).then((result) => {

            if (result['status'] !== 'success') {

                if (checkUnauthorized(router, result)) {

                    return;
                }

                console.log(result);

                return;

            }

            dashboardData = result['data'];
            hasAudienceData = 'guestorigins' in dashboardData;

            chartPeriodicConfig = setupChartPeriodic(dashboardData['trend']);
            chartCumulativeConfig = setupChartCumulative(dashboardData['cumulative']);

            let audienceConfigs = setupChartsAudience(dashboardData['guestaudience']);
            chartGenderConfig = audienceConfigs['genderchart'];
            chartAgesConfig = audienceConfigs['ageschart'];

            if (hasAudienceData) {

                chartOriginConfig = setupChartOrigins(dashboardData['guestorigins']);
            }

            keywordInfo = handleKeyword(dashboardData['keywordshistory']);

        });

    };

    let changeMapZoom = (zoom) => {

        chartOriginConfig['zoom'] = zoom;
    };

</script>


{#if dashboardData}

    <div class="main">

        <div class="home-section">

            <h1 class="pagetitle">Dashboard</h1>

            <div class="section-container">

                <section id="sec-reviews">

                    <h2 class="sectiontitle">
                        Bewertungen
                        <a class="details" href="/reviews">
                            DETAIL <img src="images/arrow-detail.svg" alt="" />
                        </a>
                    </h2>

                    <div id="reviews-total">{dashboardData['totalreviews']}</div>

                </section>

                <section id="sec-platforms">

                    <h2 class="sectiontitle">Portale</h2>

                    <div id="platforms-chart">

                    </div>

                    <table id="platforms-table">

                        <tr>

                            {#each Object.entries(dashboardData['platforms']) as [groupKey, groupItem], index(groupKey)}

                                <td class="cell-platform">

                                    <span class="platforms-bullet platform-tripadvisor"></span>
                                    <span class="platforms-platform">{groupKey}</span>

                                </td>

                                <td class="cell-reviews">

                                    <span>{groupItem['rid']}</span>
                                </td>

                                <td class="cell-percent">

                                    <span>{groupItem['pct'] + "%"}</span>
                                </td>

                            {/each}

                        </tr>

                    </table>

                </section>

                <section id="sec-charts">

                    <div class="chart-column">

                        <div id="chart-threemonths" class="chart-container">

                            <div class="chart-header">

                                <div class="chart-title chart-title-period">{periodIdentifiers[dashboardData['periodinfo']['type']]['title']}</div>

                                <div class="chart-total {getChangeClass(dashboardData['trendstats']['cum']['chg'])}">

                                    <div class="total-num">{dashboardData['trendstats']['cum']['num']}</div>
                                    <div class="total-arrow arrow-change"></div>
                                    <div class="total-change">{getChangePercent(dashboardData['trendstats']['cum']['chg'], true)}</div>

                                </div>

                                <div class="chart-legend chart-legend-period">{periodIdentifiers[dashboardData['periodinfo']['type']]['legend']}</div>

                            </div>

                            <div class="chart-body" id="chart-item-periodic" use:highcharts={chartPeriodicConfig}>

                            </div>

                            <table class="chart-meta">

                                <tbody>

                                <tr id="meta-pos">

                                    <td class="meta-identifier">
                                        Positiv
                                    </td>

                                    <td class="meta-num">
                                        {dashboardData['trendstats']['pos']['num']}
                                    </td>

                                    <td class="meta-change change-pos {getChangeClass(dashboardData['trendstats']['pos']['chg'])}">

                                        <div class="change-percent">{getChangePercent(dashboardData['trendstats']['pos']['chg'], true)}</div>
                                        <div class="change-arrow arrow-change"></div>

                                    </td>

                                </tr>

                                <tr id="meta-neu">

                                    <td class="meta-identifier">
                                        Neutral
                                    </td>

                                    <td class="meta-num">
                                        {dashboardData['trendstats']['neu']['num']}
                                    </td>

                                    <td class="meta-change change-neu {getChangeClass(dashboardData['trendstats']['neu']['chg'])}">

                                        <div class="change-percent">{getChangePercent(dashboardData['trendstats']['neu']['chg'], true)}</div>
                                        <div class="change-arrow arrow-change"></div>

                                    </td>

                                </tr>

                                <tr id="meta-neg">

                                    <td class="meta-identifier">
                                        Negativ
                                    </td>

                                    <td class="meta-num">
                                        {dashboardData['trendstats']['neg']['num']}
                                    </td>

                                    <td class="meta-change change-neg {getChangeClass(dashboardData['trendstats']['neg']['chg'])}">

                                        <div class="change-percent">{getChangePercent(dashboardData['trendstats']['neg']['chg'], true)}</div>
                                        <div class="change-arrow arrow-change"></div>

                                    </td>

                                </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                    <div class="chart-column">

                        <div id="chart-trend" class="chart-container">

                            <div class="chart-header">

                                <div class="chart-title">Übersicht Bewertungen</div>

                                <div class="chart-legend">
                                    Jährlich - seit <span class="legend-date">{new Intl.DateTimeFormat('de').format(new Date(dashboardData['earliest'] * 1000))}</span>
                                </div>

                            </div>

                            <div class="chart-body" id="chart-item-cumulative" use:highcharts={chartCumulativeConfig}></div>

                        </div>

                        <!--<div id="chart-average" class="chart-container">
    
                            <div class="chart-header">
    
                                <div class="chart-title">Durchschnitt Rating</div>
    
                                <div class="chart-legend">
                                    Monatlich - seit <span class="legend-date"></span>
                                </div>
    
                            </div>
    
                            <div class="chart-body">
    
                                -
    
                            </div>
    
                        </div>-->

                    </div>

                </section>

            </div>

        </div>
        <div class="home-section">

            <div class="section-container">

                <PropertySelection
                    on:propertychange={() => loadDashboardData()}
                />

                <section id="sec-guests">

                    <h2 class="sectiontitle">
                        Gäste
                        <a class="details" href="/guests">
                            DETAIL <img src="images/arrow-detail.svg" alt="" />
                        </a>
                    </h2>

                    {#if !hasAudienceData}

                        <div id="guests-stats">

                            <div class="stats-item" id="guests-total">

                                <img class="stats-icon" src="images/icon-allguests.svg" />

                                <div class="stats-meta">

                                    <div class="meta-title">Alle Gäste</div>

                                    <div class="meta-change">

                                        <div class="total-num">{dashboardData['guests']['total']['num']}</div>

                                    </div>

                                </div>

                            </div>

                            <div class="stats-item" id="guests-recurring">

                                <img class="stats-icon" src="images/icon-recurringguests.svg" />

                                <div class="stats-meta">

                                    <div class="meta-title">Wiederkehrende Gäste</div>

                                    <div class="meta-change">

                                        <div class="total-num">{dashboardData['guests']['revisiting']['num']}</div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    {:else}

                        <div class="chart-row">

                            <div id="chart-audience" class="chart-container">

                                <div class="chart-header">

                                    <div class="chart-title">Zielgruppe</div>

                                </div>

                                <div id="gender-container">

                                    <div id="gender-chart" use:highcharts={chartGenderConfig}></div>

                                    <div id="gender-legend">

                                        <div class="legend-item">

                                            <div class="legend-label">
                                                Männer
                                            </div>

                                            <div class="legend-stats">

                                                <img class="legend-bullet" src="/images/icon-legend-mal.svg" alt="">
                                                <div class="legend-num">{dashboardData['guestaudience']['gender']['mal'] + '%'}</div>

                                            </div>

                                        </div>

                                        <div class="legend-item">

                                            <div class="legend-label">
                                                Frauen
                                            </div>

                                            <div class="legend-stats">

                                                <img class="legend-bullet" src="/images/icon-legend-fem.svg" alt="">
                                                <div class="legend-num">{dashboardData['guestaudience']['gender']['fem'] + '%'}</div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div id="age-container" use:highcharts={chartAgesConfig}>

                                </div>

                            </div>

                            <div id="chart-origin" class="chart-container">

                                <div class="chart-header">

                                    <div class="chart-title">Herkunft</div>

                                    <div id="origin-tools">

                                        <div class="btn-group">

                                            <img
                                                    src="/images/icon-zoom-out.svg"
                                                    id="map-zoomout"
                                                    on:click={() => changeMapZoom('zoomout')}>

                                            <img
                                                    src="/images/icon-zoom-in.svg"
                                                    id="map-zoomin"
                                                    on:click={() => changeMapZoom('zoomin')}>

                                        </div>

                                    </div>

                                </div>

                                <div
                                        id="origin-container"
                                        use:highchartsmap={chartOriginConfig} >

                                </div>

                            </div>

                        </div>


                    {/if}

                </section>

                <section id="sec-keywords">

                    <h2 class="sectiontitle">
                        Keywords
                        <a class="details" href="/keywords">
                            DETAIL <img src="images/arrow-detail.svg" alt="" />
                        </a>
                    </h2>

                    <div class="chart-column">

                        <div id="chart-keywords" class="chart-container">

                            <div class="chart-header">

                                <div class="chart-title chart-title-period"></div>

                                <!--<div class="chart-total chart-total-period change-up">
    
                                    <div class="total-num">62</div>
    
                                </div>-->

                            </div>

                            <div id="keywords-container">

                                {#each Object.keys(dashboardData['keywordshistory']) as sentiment}

                                    <div id="keywords-{sentiment}" class="keywords-subcontainer">

                                        {#if keywordInfo}

                                            {#each Object.entries(keywordInfo) as [kwhId, kwhData]}

                                                {#if kwhData['sentiment'] === sentiment}

                                                    <div class="keywords-item">

                                                        <div class="keyword-text">{kwhId}</div>
                                                        <div class="keyword-chart" use:highcharts={kwhData['chartconfig']}></div>
                                                        <div class="keyword-num">{kwhData['total']}</div>

                                                    </div>

                                                {/if}

                                            {/each}

                                        {/if}

                                    </div>

                                {/each}

                            </div>

                        </div>

                    </div>

                </section>

            </div>

        </div>

    </div>
{:else}

    <div>animation</div>
{/if}






<style>

    .main {
        display: flex;
        flex-direction: row;
        align-items: unset;
        position: relative;
        margin-left: 10vh;
        width: calc(100vw - 18.6vh);
        /*padding: 2vw 4.2vw;*/
        padding: 4vh 4.2vh;
        min-height: calc(100vh - 8vh);
        background-image: url(/images/bg-home.png);
        background-repeat: no-repeat;
        background-position: center center;
        color: #383874;
    }

    section {
        display: flex;
        /*display: none;*/
        height: inherit;
    }

    section.show {
        display: flex;
    }

    .home-section {
        display: flex;
        flex-direction: column;
        width: 50%;
    }

    .home-section:last-child .section-container {
        align-items: flex-end;
        margin-top: 0;
    }

    .home-section #property-selection {
        min-width: 26.6vh;
    }

    .section-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
        margin-top: 3.6vh;
    }

    .pagetitle {
        font-family: 'Raleway', sans-serif;
        font-weight: 500;
        /*font-size: 1.77vw;*/
        font-size: 3.2vh;
    }

    .sectiontitle {
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
        font-size: 1.85vh;
        letter-spacing: 0.3px;
    }

    .sectiontitle a.details {
        margin-left: 1.15vw;
        font-size: 1.1vh;
        letter-spacing: 1px;
        color: #32325d;
    }

    .sectiontitle .details img {
        height: 0.71vh;
    }

    /*Section Reviews*/

    #reviews-total {
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 7.5vh;
    }

    /** SECTION PLATFORMS *!*/

    #platforms-table {
        display: flex;
        margin-top: 1.2vh;
        /*margin-top: 2.13vw;*/
    }

    #platforms-table tr {
        display: flex;
        border-bottom: 1px solid #DBDFF1;
    }

    #platforms-table tr:last-child {
        border-bottom: 0;
    }

    #platforms-table tr td {
        display: flex;
        align-items: center;
        padding: 1.2vh 0;
    }

    #platforms-table tr td:first-child {
        padding-left: 0;
    }

    #platforms-table tr td:last-child {
        padding-right: 0;
    }

    #platforms-table .cell-platform {
        width: 14.2vh;
        text-align: left;
    }
    #platforms-table .cell-platform span {
        text-transform: capitalize;
    }

    #platforms-table .platforms-bullet {
        display: inline-block;
        width: 0.9vh;
        height: 0.9vh;
        margin-right: 0.9vh;
        border-radius: 50%;
        background-color: #138DD8;
    }

    #platforms-table .platforms-platform {
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.85vh;
    }

    #platforms-table .cell-reviews span,
    #platforms-table .cell-percent span {
        font-family: 'Roboto', sans-serif;
    }

    #platforms-table .cell-reviews {
        width: 8.4vh;
        justify-content: center;
    }

    #platforms-table .cell-reviews span {
        font-weight: 300;
        font-size: 1.8vh;
    }

    #platforms-table .cell-percent {
        width: 5.9vh;
        justify-content: flex-end;
    }

    #platforms-table .cell-percent span {
        font-weight: 400;
        font-size: 1.8vh;
    }
    #sec-keywords .chart-column {
        width: 48vw;
    }

    #sec-keywords .chart-container {
        margin-top: 2vh;
    }

    #sec-keywords .chart-container .chart-meta {
        margin-top: 1.66vw;
    }

    #sec-keywords .chart-meta tr .meta-num {
        font-weight: 500;
    }

    #keywords-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 2vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.6vh;
    }

    .keywords-subcontainer {
        width: 21.5vw;
    }

    #keywords-container .keywords-item  {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2vh;
    }

    .keywords-subcontainer .keywords-item:last-child {
        margin-bottom: 0;
    }

    .keywords-item .keyword-text {
        width: 6vw;
        overflow-x: hidden;
        font-weight: 500;
    }

    .keywords-item .keyword-chart {
        width: 12vw;
        height: 2.5vh;
    }

    .keywords-item .keyword-num {
        font-family: 'Roboto', sans-serif;
        font-weight: 600;
    }




</style>

